(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vaniz-product-accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-vaniz-product-accordion]';
    const contentSelector = '.vaniz-product-accordion__content';
    const contentInnerSelector = '.vaniz-product-accordion__content-inner';
    const itemSelector = '.vaniz-product-accordion__item';
    const summarySelector = '.vaniz-product-accordion__summary';
    const easing = 'cubic-bezier(0.22, 1, 0.36, 1)';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const timers = new WeakMap();
    const frames = new WeakMap();

    const getDuration = (root) => {
      const parsed = parseInt(root.dataset.animationDuration, 10);
      return Number.isFinite(parsed) ? Math.max(parsed, 0) : 720;
    };

    const setTransition = (content, inner, duration) => {
      const opacityDuration = Math.round(duration * 0.72);
      content.style.transition = `height ${duration}ms ${easing}, opacity ${opacityDuration}ms ease`;
      inner.style.transition = `transform ${duration}ms ${easing}`;
    };

    const clearMotion = (details) => {
      window.clearTimeout(timers.get(details));
      window.cancelAnimationFrame(frames.get(details));
      timers.delete(details);
      frames.delete(details);
    };

    const scheduleSettle = (details, duration, callback) => {
      timers.set(details, window.setTimeout(callback, duration + 40));
    };

    const settleOpen = (details, content) => {
      details.dataset.state = 'open';
      details.classList.remove('is-closing');
      content.style.height = 'auto';
      content.style.opacity = '1';
    };

    const settleClosed = (details, content, inner) => {
      details.dataset.state = 'closed';
      details.open = false;
      details.classList.remove('is-closing');
      content.style.height = '0px';
      content.style.opacity = '0';
      inner.style.transform = 'translateY(-4px)';
    };

    const closeItem = (details, content, inner, duration) => {
      clearMotion(details);

      if (reducedMotion.matches) {
        settleClosed(details, content, inner);
        return;
      }

      details.open = true;
      details.dataset.state = 'closing';
      details.classList.add('is-closing');
      setTransition(content, inner, duration);
      content.style.height = `${content.getBoundingClientRect().height}px`;
      content.style.opacity = getComputedStyle(content).opacity;
      content.offsetHeight;

      frames.set(details, requestAnimationFrame(() => {
        content.style.height = '0px';
        content.style.opacity = '0';
        inner.style.transform = 'translateY(-4px)';
      }));

      scheduleSettle(details, duration, () => settleClosed(details, content, inner));
    };

    const closeOtherItems = (root, currentDetails, duration) => {
      root.querySelectorAll(itemSelector).forEach((details) => {
        if (details === currentDetails) return;

        const state = details.dataset.state || (details.open ? 'open' : 'closed');
        if (state === 'closed') return;

        const content = details.querySelector(contentSelector);
        const inner = details.querySelector(contentInnerSelector);
        if (!content || !inner) return;

        closeItem(details, content, inner, duration);
      });
    };

    const openItem = (root, details, content, inner, duration) => {
      clearMotion(details);
      closeOtherItems(root, details, duration);

      if (reducedMotion.matches) {
        details.open = true;
        details.dataset.state = 'open';
        details.classList.remove('is-closing');
        content.style.height = 'auto';
        content.style.opacity = '1';
        inner.style.transform = 'translateY(0)';
        return;
      }

      const startHeight = details.open ? content.getBoundingClientRect().height : 0;
      details.open = true;
      details.dataset.state = 'opening';
      details.classList.remove('is-closing');
      setTransition(content, inner, duration);
      content.style.height = `${startHeight}px`;
      content.style.opacity = getComputedStyle(content).opacity;
      content.offsetHeight;

      frames.set(details, requestAnimationFrame(() => {
        content.style.height = `${inner.scrollHeight}px`;
        content.style.opacity = '1';
        inner.style.transform = 'translateY(0)';
      }));

      scheduleSettle(details, duration, () => settleOpen(details, content));
    };

    const prepareItem = (root, details) => {
      const summary = details.querySelector(summarySelector);
      const content = details.querySelector(contentSelector);
      const inner = details.querySelector(contentInnerSelector);

      if (!summary || !content || !inner || summary.dataset.vanizAccordionReady === 'true') return;

      const duration = getDuration(root);
      summary.dataset.vanizAccordionReady = 'true';
      details.dataset.state = details.open ? 'open' : 'closed';
      content.style.overflow = 'hidden';
      content.style.height = details.open ? 'auto' : '0px';
      content.style.opacity = details.open ? '1' : '0';
      inner.style.transform = details.open ? 'translateY(0)' : 'translateY(-4px)';

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        const state = details.dataset.state || (details.open ? 'open' : 'closed');

        if (state === 'open' || state === 'opening') {
          closeItem(details, content, inner, duration);
          return;
        }

        openItem(root, details, content, inner, duration);
      });
    };

    const init = (scope = document) => {
      scope.querySelectorAll(selector).forEach((root) => {
        root.querySelectorAll(itemSelector).forEach((details) => prepareItem(root, details));
      });
    };

    init();
    document.addEventListener('DOMContentLoaded', () => init());
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
